import type { PlanType } from '@uniquegood/realworld-admin-interface';

export type PricingTier = 'ALL' | 'PRO' | 'ENTERPRISE' | 'TEACHER' | 'CLASS' | 'REALWORLD';

/**
 * PricingTier를 PlanType으로 변환
 */
export const pricingTierToPlanType = (tier: PricingTier): PlanType | null => {
  // ALL은 모든 요금제를 의미하므로 null 반환 (API에서 처리)
  if (tier === 'ALL') {
    return null;
  }
  
  const mapping: Record<Exclude<PricingTier, 'ALL'>, PlanType> = {
    PRO: 'Pro',
    ENTERPRISE: 'Enterprise',
    TEACHER: 'Teacher',
    CLASS: 'Class',
    REALWORLD: 'Realworld',
  };
  return mapping[tier];
};

/**
 * PlanType을 PricingTier로 변환
 */
export const planTypeToPricingTier = (planType: PlanType): PricingTier => {
  const mapping: Record<PlanType, PricingTier> = {
    Free: 'ALL', // Free는 모든 요금제 사용 가능과 동일
    Pro: 'PRO',
    Enterprise: 'ENTERPRISE',
    Teacher: 'TEACHER',
    Class: 'CLASS',
    Realworld: 'REALWORLD',
  };
  return mapping[planType] || 'ALL';
};

/**
 * PlanType 배열을 PricingTier 배열로 변환
 */
export const planTypesToPricingTiers = (planTypes: PlanType[]): PricingTier[] => {
  // 빈 배열이면 빈 배열 반환 (아무것도 표시하지 않음)
  if (planTypes.length === 0) {
    return [];
  }
  
  // Free만 있으면 ALL 반환 (모든 요금제 사용 가능)
  if (planTypes.length === 1 && planTypes[0] === 'Free') {
    return ['ALL'];
  }
  
  return planTypes.map(planTypeToPricingTier);
};

/**
 * PricingTier 배열을 PlanType 배열로 변환
 */
export const pricingTiersToPlanTypes = (tiers: PricingTier[]): PlanType[] => {
  // ALL이 포함되어 있으면 모든 요금제 반환 (모든 요금제 사용 가능)
  if (tiers.includes('ALL')) {
    return ['Free', 'Pro', 'Enterprise', 'Teacher', 'Class', 'Realworld'];
  }
  
  return tiers
    .map(pricingTierToPlanType)
    .filter((planType): planType is PlanType => planType !== null);
};

